/**
 * C8 -- a finding is a link everywhere it is named.
 *
 * Five surfaces named a finding in plain text: the cascade card, the
 * entity page, the capability-map drawer, the MVB findings panel and
 * the board snapshot. Each was a dead end -- the reader could see WHAT
 * was wrong and had no way to reach it, so the only route to a finding
 * was the topnav search, by title.
 *
 * One component rather than five call sites, so a sixth surface cannot
 * reintroduce the plain text. Where a surface genuinely has no id --
 * the board carried a title and nothing else until C7 -- it degrades to
 * text rather than linking somewhere that does not exist.
 */
import { Link } from "react-router-dom";

export function findingPath(id: string): string {
  return `/twin/findings/${id}`;
}

export function FindingLink({
  id,
  title,
  className,
}: {
  id: string | null | undefined;
  title: string;
  className?: string;
}) {
  if (!id) {
    return (
      <span data-testid="finding-link-plain" className={className}>
        {title}
      </span>
    );
  }
  return (
    <Link
      data-testid="finding-link"
      data-finding-id={id}
      to={findingPath(id)}
      className={`${className ?? ""} hover:text-brand-brassDark hover:underline`.trim()}
    >
      {title}
    </Link>
  );
}
